import { Procedure as Data } from '@/typings/api/Procedure'
import { Model, createMessages } from '@/helpers/Model'


export class ProcedureModel extends Model<Data> {
    public static readonly page_title = createMessages({
      create: 'Добавить процедуру',
      edit: 'Редактировать процедуру',
      view: (data: ProcedureModel) => 'Публикация «{name}»'
        .replace('{name}', data.name || '...'),
      list: 'Оценочные процедуры',
    });

    public static readonly response_success = createMessages({
      ...Model.response_success,
    });

    public static readonly response_error = createMessages({
      ...Model.response_error,
    });
}
